import script from "./WithdrawsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./WithdrawsView.vue?vue&type=script&lang=ts&setup=true"

import "./WithdrawsView.vue?vue&type=style&index=0&id=4069e1b0&lang=scss"

const __exports__ = script;

export default __exports__